import { PropsWithChildren, useEffect, useRef, useState } from 'react'
import { RxDatabase } from 'rxdb'
import { Provider } from 'rxdb-hooks'

import { initialize } from '~/db/initialize'
import { withSuppressRxDbFreeDatabaseWarning } from '~/db/utils'

type RxDbProviderProps = PropsWithChildren & {
  isMemoryMode?: boolean
}

export const RxDbProvider = ({ children, isMemoryMode }: RxDbProviderProps) => {
  const [db, setDb] = useState<RxDatabase>()
  const isInitializationStarted = useRef(false)

  useEffect(() => {
    if (isInitializationStarted.current) return

    isInitializationStarted.current = true

    void withSuppressRxDbFreeDatabaseWarning(initialize, isMemoryMode).then(setDb)
  }, [isMemoryMode])

  useEffect(
    () => () =>
      void db
        ?.requestIdlePromise()
        .then(() => db.destroy())
        .catch(error => {
          console.error({ message: 'Error destroying RxDB database', error })
        }),
    [db],
  )

  if (!db) return null

  return <Provider db={db}>{children}</Provider>
}
